<div *ngIf="modalData.name === 'openCreateAction'" >
  <div class="row">
    <div class="col-md-10">
      <h3 >Action</h3>


    </div>

  <div class="col-md-2">

    <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
      <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
    </span>
  </div>

  </div>


  <form [formGroup]="actionForm">

    <div class="row mt-4 mb-5 justify-content-center">

      <div class="col-md-12">

        <div class="input_container">
          <label for="">Action title</label>
          <input type="text" formControlName="ActionTitle" placeholder="Enter Action Title"/>
        </div>

       </div>





      <div class="col-md-12">

        <div class="input_container">
          <label for="">Description</label>
          <textarea formControlName="ActionDescription" cols="30" rows="10"></textarea>
        </div>

       </div>


    </div>

    <div class="submit">
      <button class="submit_button" [hidden]="actionForm.invalid" (click)="submitAction(actionForm.value)">
        Save
      </button>
    </div>

  </form>
</div>



<div class="container" *ngIf="modalData.name === 'openActionParty'">
  <div class="custom_modal_table_three_row" style="margin-top: 0rem;">

    <!-- <form [formGroup]="correspondenceActionPartyFormArray">
    <span class="head" > <mat-checkbox class=" mr-5" [checked]="isNotifySelect" (change)="onCheckAll($event)" ></mat-checkbox> Select all</span>

    <div class="the_edited" #stake>
        <div class="thead">
            <span class="head">S/N</span>
            <span class="head">Action</span>
            <span class="head">Action Party Name</span>
        </div>

        <div class="tbody" formArrayName="CorrespondenceActionParties">
            <div class="td" *ngFor="let party of correspondenceActionPartyFormArray.get('CorrespondenceActionParties')['controls']; index as i" [formGroupName]="i">
                <span class="head">{{i + 1}}</span>

                <span class="head" > <mat-checkbox class=" mr-5" formControlName="isSelected"></mat-checkbox></span>

                <Span class="head">{{party.value.CorrespondenceActionPartyName}}</Span>

            </div>
        </div>

        <div class="submit mt-4">

          <button type="submit"   class="submit_button" type="submit" (click)="saveNotification(correspondenceActionPartyFormArray.value)" >Submit</button>

         </div>

    </div>
  </form> -->

  <div class="card mt-3 ">
    <div class="table-responsive">
      <form [formGroup]="correspondenceActionPartyFormArray">
        <span class="head" > <mat-checkbox class=" mr-5" [checked]="isNotifySelect" (change)="onCheckAll($event)" ></mat-checkbox> Select all</span>

    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Action Party Name</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody formArrayName="CorrespondenceActionParties">
        <tr *ngFor="let party of correspondenceActionPartyFormArray.get('CorrespondenceActionParties')['controls']; index as i" [formGroupName]="i"
        style="cursor: pointer;"
        >
          <th scope="row">{{i + 1}}</th>
          <td>{{party.value.CorrespondenceActionPartyName}}</td>
          <td> <mat-checkbox class=" mr-5" formControlName="isSelected"></mat-checkbox></td>
        </tr>

      </tbody>
    </table>

    <div class="submit mt-4">

      <button type="submit"   class="submit_button" type="submit" (click)="saveNotification(correspondenceActionPartyFormArray.value)" >Submit</button>

     </div>
     </form>
  </div>
  </div>
</div>
</div>

